package com.ijoin.data.repository

import com.ijoin.data.api.BookingApi
import com.ijoin.data.model.Booking
import com.ijoin.data.model.CreateBookingRequest
import com.ijoin.data.model.EventBookingResult
import com.ijoin.data.model.EventTicketBookingRequest
import com.ijoin.data.model.TimeSlot
import com.ijoin.platform.createTimeZone
import com.ijoin.util.datetime.currentDateTimeInTimeZone
import com.ijoin.util.datetime.currentLocalDate
import com.ijoin.util.datetime.toLocalDateCompat
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.minus
import kotlinx.datetime.plus

class BookingRepository(
    private val bookingApi: BookingApi = BookingApi(),
) {
    suspend fun getAvailableSlots(
        eventId: String,
        monthStart: LocalDate,
        eventTimeZoneId: String? = null,
    ): Result<Map<LocalDate, List<TimeSlot>>> {
        val monthEnd = monthStart.plus(DatePeriod(months = 1)).minus(DatePeriod(days = 1))
        val targetZone = if (!eventTimeZoneId.isNullOrBlank()) createTimeZone(eventTimeZoneId) else TimeZone.currentSystemDefault()
        val now = currentDateTimeInTimeZone(eventTimeZoneId)
        return bookingApi.getAvailableSlots(eventId, monthStart, monthEnd)
            .map { slots ->
                slots
                    .filter { slot ->
                        val slotDateTime = slot.startTime.toLocalDateCompat()
                        slotDateTime > now.date ||
                            (slotDateTime == now.date && slotDateTime >= currentLocalDate())
                    }
                    .groupBy { it.startTime.toLocalDateCompat() }
            }
    }

    suspend fun createBooking(
        eventId: String,
        slotIds: List<Long>,
        clientNotes: String? = null,
    ): Result<Booking> {
        val request = CreateBookingRequest(
            clientId = null,
            eventId = eventId,
            timeSlotIds = slotIds,
            clientNotes = clientNotes,
        )
        return bookingApi.createBooking(request)
    }

    suspend fun bookEventTickets(request: EventTicketBookingRequest): Result<EventBookingResult> {
        return bookingApi.bookEventTickets(request)
    }

    suspend fun pingReservation(bookingId: Long): Result<Unit> {
        return bookingApi.pingReservation(bookingId)
    }
}
